import React, { useEffect, useState } from "react";
import Drop from "./Drop";
import { PropTypes } from "prop-types";
import style from "./ListOfdata.module.css";
import DropCard from "./DropCard";
import CommonButton from "../CommonButton";
import AddIcon from "@mui/icons-material/Add";
import CustomSelect from "../Select/CustomSelect";
import { useCallback } from "react";
import { Typography, Box, TextField } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { getBlocksAsPerLobName } from "../../Services/approval.service";
import useToaster from "../../customHook/useToaster";
import { isLoadingStateReducer } from "../../Redux/Slice/loginSlice";

const theme = createTheme({
  palette: {
    textField_bordercolor: {
      main: "#CCC",
    },
  },
});

const Listofdata = ({
  data,
  label,
  blockCount,
  options,
  isReassign,
  reassignType,
  investigatorDetails,
  valueOfDropDown,
  setDropDownValue = () => {},
  handleChange = () => {},
  onAssign = () => {},
}) => {
  const [isAssign, setIsAssign] = useState(false);
  const [isSelectAllClicked, setIsSelectAllClicked] = useState(false);
  const [Investigator, setInvestigator] = useState([]);
  const [assignDataList, setAssignDataList] = useState([]);
  const [dataTosend, setDatatoSend] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [isLocationSelectOpen, setIsLocationSelectOpen] = useState(false);
  const { showToast } = useToaster();
  const [locationDropdownStatus, setLocationDropdownStatus] = useState([
    { id: 0, isToggle: false },
    { id: 1, isToggle: false },
    { id: 2, isToggle: false },
    { id: 3, isToggle: false },
    { id: 4, isToggle: false },
  ]);

  const assignHandler = useCallback(() => {
    if (valueOfDropDown) {
      setIsAssign(true);
    }
    if (dataTosend?.length || investigatorDetails?.blocksAssigned?.length) {
      let isNotLoaction = dataTosend?.find((obj) => !obj?.state || !obj?.city);
      if (isNotLoaction) {
        return showToast("Please provide vendor location.", "warning", true);
      }
      if (isReassign && !remarks) {
        return showToast("Please provide rejection remark.", "warning", true);
      }
      onAssign(dataTosend, remarks, resetStates);
    } else {
      showToast("Please select vendor blocks.", "warning", true);
    }
  }, [isReassign, investigatorDetails, dataTosend, remarks, valueOfDropDown]);
  const resetStates = () => {
    setDatatoSend([]);
    setDropDownValue("");
    setRemarks("");
    setIsSelectAllClicked(false);
    setIsAssign(false);
    setAssignDataList(data);
  };
  const selectAllHandler = () => {
    setIsSelectAllClicked((prev) => {
      if (!prev && isAssign)
        showToast(
          "Please tap on vendor block to assign blocks",
          "info",
          true,
          false
        );
      return !prev;
    });
  };
  const handleRemarkChange = (e) => {
    setRemarks(e.target.value);
  };

  const mapAssignedData = useCallback(
    (selectedItem, investigator, assignAll = false, selectedDetails) => {
      let { state = "", city = "", isSpecialised = 0 } = selectedDetails;
      const data = assignDataList?.map((item) => {
        let dataArr = {};
        let setdataArr = () => {
          let arr = [...item?.investigator, investigator];
          arr.sort((a, b) => a - b);
          dataArr = {
            ...item,
            investigator: [...new Set(arr)],
            isAssigned: true,
          };
        };
        if (
          item?.block_master_id === selectedItem?.block_master_id ||
          assignAll
        ) {
          setdataArr();
        } else {
          dataArr = {
            ...item,
          };
        }
        return dataArr;
      });
      //modify data for api call
      let dataForApi = [];
      data.forEach((element, index) => {
        if (element?.isAssigned) {
          element?.investigator.forEach((item, index) => {
            dataForApi[item - 1] = {
              blocksAssigned: dataForApi[item - 1]?.blocksAssigned?.length
                ? [
                    ...dataForApi[item - 1]?.blocksAssigned,
                    element?.block_master_id,
                  ]
                : [element?.block_master_id],
              // locationToAssign: "Mumbai", // this will be based on location drop down design is yet to come
              state: dataTosend[item - 1]?.state || "",
              city: dataTosend[item - 1]?.city || "",
              isSpecialised: dataTosend[item - 1]?.isSpecialised || 0,
            };
          });
        }
      });
      //update state, city and isSpecialised of selected investigator
      if (dataForApi[investigator - 1]) {
        dataForApi[investigator - 1] = {
          ...dataForApi[investigator - 1],
          state,
          city,
          isSpecialised,
        };
      }
      setDatatoSend(dataForApi);
      setAssignDataList(data);
    },
    [assignDataList]
  );

  const deleteHandler = (e, id, investigator) => {
    let updatedItem = assignDataList.map((item, index) => {
      let arr = {};
      if (item?.block_master_id === id) {
        let invArr = item?.investigator?.filter(
          (value) => value !== investigator
        );
        arr = {
          ...item,
          investigator: invArr,
          isAssigned: invArr.length ? true : false,
        };
      } else {
        arr = { ...item };
      }
      return arr;
    });
    let updatedDataToSend = dataTosend
      ?.map((item) => {
        return {
          ...item,
          blocksAssigned: item?.blocksAssigned?.filter(
            (blockId) => blockId !== id
          ),
        };
      })
      ?.filter((obj) => obj?.blocksAssigned?.length);
    setAssignDataList(updatedItem);
    setDatatoSend(updatedDataToSend);
  };

  const locationDropClickHandler = (item, index) => {
    setLocationDropdownStatus((prev) => {
      const updatedStatus = [...prev];
      updatedStatus[index] = {
        ...updatedStatus[index],
        isToggle: !updatedStatus[index].isToggle,
      };
      return updatedStatus;
    });
    setIsLocationSelectOpen((prev) => !prev);
  };

  useEffect(() => {
    if (valueOfDropDown) {
      setInvestigator([
        ...Array(valueOfDropDown)
          ?.fill("")
          ?.map((value, index) => index + 1),
      ]);
    }
    if (isReassign) {
      setIsAssign(true);
    }
  }, [valueOfDropDown, isReassign]);

  useEffect(() => {
    if (data) {
      const modifiedData = data.map((item, index) => {
        let modifiedInvestigator =
          assignDataList?.[index]?.investigator?.filter(
            (data) => data <= valueOfDropDown
          ) || [];
        let isPrevSelected = false;
        if (
          isReassign &&
          investigatorDetails?.blocksAssigned?.includes(item?.block_master_id)
        ) {
          isPrevSelected = true;
        }
        if (
          isReassign &&
          investigatorDetails?.blocksAssigned?.includes(
            item?.block_master_id
          ) &&
          valueOfDropDown <= 1
        ) {
          modifiedInvestigator?.push(1);
        }
        return {
          ...item,
          isPrevSelected,
          investigator: modifiedInvestigator,
          isAssigned: modifiedInvestigator?.length ? true : false,
        };
      });

      setAssignDataList(modifiedData);
    }
  }, [data, valueOfDropDown, isReassign, investigatorDetails]);

  return (
    <div style={{ overflow: "scroll" }}>
      {/* <h1 style={{ color: "#505050", fontWeight: "600" }}>{label}</h1> */}
      <div style={{ width: "50%", marginTop: "1.6rem" }}>
        <CustomSelect
          sx={{ width: "35rem" }}
          label={"Count of Investigator"}
          placeholder="Select"
          options={options}
          handleChange={(e) => {
            // setInvestigator([]);
            // setInvestigator((prev) => [...prev, i]);
            handleChange(e);
          }}
          customSelectValue={valueOfDropDown}
          disabled={isReassign && reassignType === "same"}
        />
      </div>
      <h2
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "500",
          color: " #505050",
          fontSize: "1.4rem",
          marginBottom: "1.4rem",
          marginTop: "1.4rem",
        }}
      >
        <span>{blockCount}</span>
        {isReassign && (
          <span style={{ color: "#AFAFAF", fontSize: "1rem" }}>
            <em
              style={{
                display: "inline-block",
                marginRight: "8px",
                width: "1rem",
                height: "1rem",
                border: "1px solid rgba(228, 33, 37, 1)",
                background: "rgba(228, 33, 37, 0.2)",
              }}
            ></em>
            Previously Assigned Blocks
          </span>
        )}
      </h2>
      <div className={style["list_of-data-container"]}>
        {assignDataList?.map((data, id) => {
          return (
            <div style={{ position: "relative" }} draggable={false}>
              <Drop
                label={data?.block_name}
                key={id}
                id={data?.block_master_id}
                isReassign={isReassign}
                isAssigned={assignDataList}
                isPrevSelected={data?.isPrevSelected}
                isDropped={data?.isAssigned}
                isDroppedLocation={data?.investigator}
              />
            </div>
          );
        })}
        <div style={{ width: "fit-content" }}>
          <CommonButton
            label={isSelectAllClicked ? "Deselect All" : "Select All"}
            isColor
            onClick={selectAllHandler}
            removeBorder
            isHover
            hoverColor={"#59CE8F"}
            textColor="white"
            backgroundColor={"#59CE8F"}
            fontSize={"1rem"}
            isEndIcon
            endIcon={<AddIcon sx={{ fontSize: "1.5rem" }} />}
            rightAlign
          />
        </div>
      </div>
      {isAssign && (
        <div className={style["drop-card-main_conatiner"]}>
          {Investigator?.map((item, index) => {
            return (
              <DropCard
                data={assignDataList}
                label={`Vendor ${index + 1}`}
                investigator={index + 1}
                investigatorDetails={investigatorDetails}
                location={"Location"}
                isReassign={isReassign}
                reassignType={reassignType}
                isLocationSelectOpen={locationDropdownStatus[index].isToggle}
                key={index}
                locationDropClickHandler={() =>
                  locationDropClickHandler(item, index)
                }
                // droppedItems={droppedItems}
                isAssigned={assignDataList}
                droppedItemDetails={(selectedItem, selectedDetails) => {
                  // setDroppedItems((prev) => {
                  //   return [
                  //     ...prev,
                  //     {
                  //       selectedItem,
                  //       investigator: [index + 1],
                  //     },
                  //   ];
                  // });
                  mapAssignedData(
                    selectedItem,
                    index + 1,
                    false,
                    selectedDetails
                  );
                }}
                onTapped={(data, investigator, selectedDetails) => {
                  setIsSelectAllClicked(false);
                  mapAssignedData(data, investigator, true, selectedDetails);
                }}
                onDeleteItem={deleteHandler}
                isSelectAll={isSelectAllClicked}
                mapAssignedData={mapAssignedData}
                setDatatoSend={setDatatoSend}
              />
            );
          })}
        </div>
      )}

      {isReassign && (
        <Box
          component="form"
          sx={{
            "& .MuiInputBase-root": {
              padding: "10px",
            },
            marginTop: "2rem",
          }}
          noValidate
          autoComplete="off"
        >
          <div>
            <Typography sx={{ color: "#7C7C7C", fontSize: "1.4rem" }}>
              Remarks
            </Typography>
          </div>
          <div>
            <ThemeProvider theme={theme}>
              <TextField
                inputProps={{
                  style: { fontSize: "1.2rem", lineHeight: "1.8rem" },
                }}
                sx={{ width: "100%" }}
                color="textField_bordercolor"
                multiline
                margin="none"
                placeholder="Enter Remarks"
                rows={3}
                value={remarks}
                onChange={handleRemarkChange}
              />
            </ThemeProvider>
          </div>
        </Box>
      )}

      <div style={{ width: "11rem", marginTop: "1.6rem" }}>
        <CommonButton
          label="Assign"
          filledButton
          onClick={assignHandler}
          fontSize="1.4rem"
          sx={{ width: "10rem", height: "4rem" }}
        />
      </div>
    </div>
  );
};
Listofdata.propTypes = {
  data: PropTypes.object,
  label: PropTypes.string,
  blockCount: PropTypes.string,
  dropDownValue: PropTypes.string,
  setDropDownValue: PropTypes.func,
  handleChange: PropTypes.func,
  options: PropTypes.array,
};
export default Listofdata;
